<template>
    <div style="height: 100%;">
        <div class="search-box">
            <div class="tab-key-box">
                <div class="tab-key-item" @click="handleClick(item)" v-for="(item, index) in tabOptions" :key="index"
                    :class="{ 'tab-active': currentTab == item.value }">{{ item.label }}</div>
            </div>
            <div class="input-box" v-if="currentTab=='studyRecord'">
                <div @click="search">院校筛选</div>
                <el-select class="el-select" @change="search" v-model="pages.college" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <div @click="search" style="margin-right: 1rem;">搜索</div>
                <el-input class="el-input" v-model="pages.keywords" @keydown.enter.native="search" clearable @clear="search" style="width: 20rem;"
                    placeholder="请输入关键字">
                    <template slot="prefix">
                        <div class="search-ipt-box">
                            <img style="cursor: pointer;width: 16px;height: auto;" src="../../../assets/image/magSys/search.png" @click="search" alt="">
                        </div>
                    </template>
                </el-input>
            </div>
        </div>
        <div class="content-box">
            <Table :totalSize="pages.total" :pagination="true" :serialNumber="true" :operationWidth="350"
                    @changeCurrentPage="changeCurrentPage" @changePageSize="changePageSize" :currentPage="pages.current"
                    :pageSize="pages.size" navHeight=40 ref="table" :tableData="tableData" :tableKey="tableKey">
                    <template slot="trainingCount" slot-scope="data">
                        <p class="blue-color" @click="viewTrainFrequency(data.data.row)">{{ data.data.row.trainingCount }}</p>
                    </template>
                    <template slot="finishingRate" slot-scope="data">
                       <p>{{ data.data.row.finishingRate?(data.data.row.finishingRate+'%'):'' }}</p>
                    </template>
                    <template slot="userName" slot-scope="data">
                       <p>{{ data.data.row.tenantId==tenantId?data.data.row.userName:(data.data.row.userName?(data.data.row.userName[0]+'**'):'') }}</p>
                    </template>
                    <template slot="className" slot-scope="data">
                       <p>{{ data.data.row.tenantId==tenantId?data.data.row.className:(data.data.row.className?(data.data.row.className[0]+'**'):'') }}</p>
                    </template>
            </Table>
        </div>
        <train-frequency :softwareItem="softwareItem" ref="train_frequency" ></train-frequency>
    </div>
</template>

<script>
import TrainFrequency from './TrainFrequency.vue';
import { PageQuerySoftwareLearningRecord,QuerySoftwareTrainingTenantList,PageQuerySoftwareUseRecord } from '@/api/software';
    export default {
  components: { TrainFrequency },
  props:['softwareItem'],
        data(){
            return{
                tabOptions:[
                    {
                        label:'学习记录',
                        value:'studyRecord'
                    },
                    {
                        label:'使用记录',
                        value:'useRecord'
                    },
                ],
                pages:{
                    current:1,
                    size:10,
                    keywords:'',
                    /**院校过滤 */
                    college:''
                },
                tableKey1:[
                    {
                        name:'姓名',
                        value:'userName',
                        slot:'userName'
                    },
                    {
                        name:'所属院校',
                        value:'schoolName',
                    },
                    {
                        name:'班级',
                        value:'className',
                        slot:'className'
                    },
                    {
                        name:'实训时长',
                        value:'trainingTime'
                    },
                    {
                        name:'完成度',
                        value:'finishingRate',
                        slot:'finishingRate'
                    },
                    {
                        name:'实训次数',
                        value:'trainingCount',
                        slot:'trainingCount'
                    },
                    {
                        name:'最后上线时间',
                        value:'lastOnlineTime'
                    },
                ],
                tableKey2:[
                    {
                        name:'使用次数',
                        value:'recordCount'
                    },
                    {
                        name:'使用院校',
                        value:'useTenantName'
                    },
                    {
                        name:'使用时长',
                        value:'useTime'
                    },
                    {
                        name:'最后上线时间',
                        value:'lastCreateTime'
                    },
                ],
                tableKey:[],
                /**列表数据 */
                tableData:[],
                /**院校可选项 */
                options:[],
                currentTab:'studyRecord'
            }
        },
        computed:{
            tenantId(){
                return this.$store.state.user.userInfo.tenantId;
            }
        },
        methods:{
            /**切换tab */
            handleClick(item){
                this.currentTab=item.value;
                this.initData();
                if(this.currentTab=='studyRecord'){
                    this.pageQuerySoftwareLearningRecord();
                }else{
                    this.pageQuerySoftwareUseRecord();
                }
            },
            /**查询软件实训租户列表 */
            querySoftwareTrainingTenantList(){
                QuerySoftwareTrainingTenantList(this.softwareItem.softwareCode).then(res=>{
                    if(res.code==200){
                        this.options=res.data.map(item=>{
                            return {
                                label:item.tenantName,
                                value:item.tenantId
                            }
                        })
                        this.options=[{label:'全部',value:''},...this.options];
                    }
                })
            },
            /**获取软件使用记录 */
            pageQuerySoftwareUseRecord(){
                let params={
                "current": this.pages.current,
                "size": this.pages.size,
                "softwareCode": this.softwareItem.softwareCode
                }
                PageQuerySoftwareUseRecord(params).then(res=>{
                    if(res.code==200){
                        this.tableData=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            /**查看实训次数 */
            viewTrainFrequency(data){
                let dialog=this.$refs.train_frequency;
                if(dialog){
                    dialog.detail=data;
                    dialog.dialogVisible=true;
                    dialog.viewTrainList();
                }
            },
            /**分页查询仿真软件学习记录 */
            pageQuerySoftwareLearningRecord(){
                let params={
                "current": this.pages.current,
                "size": this.pages.size,
                "softwareCode":this.softwareItem.softwareCode,
                "tenantType": this.pages.college,
                "userName":this.pages.keywords
                }
                PageQuerySoftwareLearningRecord(params).then(res=>{
                    if(res.code==200){
                        this.tableData=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            /**切换tab初始化数据 */
            initData(){
                this.pages.current=1;
                this.pages.keywords='';
                this.pages.college='';
                var obj={
                    studyRecord:this.tableKey1,
                    useRecord:this.tableKey2
                }
                this.tableKey=obj[this.currentTab];
                this.tableData=[];
            },
            search(){
                this.pages.current=1;
                this.pageQuerySoftwareLearningRecord();
            },
            changeCurrentPage(e){
                this.pages.current=e;
                if(this.currentTab=='studyRecord'){
                    this.pageQuerySoftwareLearningRecord();
                }else{
                    this.pageQuerySoftwareUseRecord();
                }
            },
            changePageSize(e){
                this.pages.size=e;
                this.pages.current=1;
                if(this.currentTab=='studyRecord'){
                    this.pageQuerySoftwareLearningRecord();
                }else{
                    this.pageQuerySoftwareUseRecord();
                }
            }
        },
        mounted(){
            this.initData();
            this.search();
            this.querySoftwareTrainingTenantList();
        },
        destroyed(){
            this.$store.commit('course/changeOperation','');
            this.$store.commit('backend/changeOptlabel','');
        }
    }
</script>

<style lang="less" scoped>
.tab-key-box {
    display: flex;
    background: #ffffff;
    border: 1px solid #e8ecef;
    border-radius: 1rem;
    box-shadow: 0px 0px 2.9rem 0px rgba(180, 190, 220, 0.30);
    width: 14rem;
    height: 4rem;
    .tab-key-item {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--blue);
        cursor: pointer;
    }

    &> :nth-child(1) {
        border-top-left-radius: 1rem;
        border-bottom-left-radius: 1rem;
        transition: all 0.3s;
    }

    &> :nth-child(2) {
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
        transition: all 0.3s;
    }
}
.tab-active {
    color: #ffffff !important;
    background-color: var(--blue) !important;
}
.search-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.input-box {
    display: flex;
    align-items: center;
    color: #334681;

    &> :nth-child(1) {
        margin-right: 1rem;
    }
.search-ipt-box{
    display: flex;
    align-items: center;
    width: 3.5rem;
    justify-content: center;
    height: 100%;
}
}
.el-input{
    /deep/.el-input__inner{
    height: 4rem;
    border-radius: 1rem;
    padding-left: 3.5rem;
}
}
.el-select{
    margin-right: 3rem;
    /deep/.el-input__inner{
    height: 4rem;
    border-radius: 1rem;
}
}
.content-box{
    height: calc(100% - 6.2rem);
    margin-top: 2.4rem;
    /deep/.el-table--border th {
    background-color: #ffffff !important;
}
}
.blue-color{
    color: var(--blue);
    cursor: pointer;
}
</style>